import { Outlet, Navigate, useLocation } from "react-router-dom"


import { UserContext } from "../contexts/user.context";
import {  useContext  } from "react";


const PrivateRoutes =() =>{
    
    const { currentUser, is_fsline_setup, positionUser } = useContext(UserContext);
    const location = useLocation();
    const pathname = location?.pathname ?? '';
    const storedPosition = localStorage.getItem("position");
    const isBookkeeper = (positionUser ?? storedPosition) === 'Bookkeeper_';

    return(
        (currentUser !==null)
          ? (!isBookkeeper && Number(is_fsline_setup) === 0 && pathname !== '/setup/fsline' && pathname !== '/change/password'
              ? <Navigate to="/setup/fsline"/>
              : <Outlet/>)
          : <Navigate to="/"/>
    )
}

export default PrivateRoutes
